var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoin28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#F5B027",
    stroke: "#FFCF0D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.445 18.791v-.744c1.834-.152 2.871-1.078 2.871-2.572 0-1.266-.738-2.045-2.244-2.368l-.627-.128v-2.086c.615.087 1.055.527 1.073 1.06h1.634c-.023-1.353-1.078-2.308-2.707-2.46v-.798h-.82v.797c-1.746.14-2.777 1.067-2.777 2.508 0 1.225.755 2.033 2.162 2.361l.615.147v2.18c-.732-.077-1.23-.51-1.271-1.09h-1.676c.006 1.43 1.113 2.355 2.947 2.46v.733h.82Zm1.207-3.117c0 .592-.445.973-1.207 1.02v-2.04c.82.153 1.207.48 1.207 1.02Zm-3.105-3.838c0-.522.445-.914 1.078-.95v1.923c-.709-.141-1.078-.48-1.078-.973Z",
    fill: "#FFCF0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin28);
export default __webpack_public_path__ + "static/media/coin_28.2d52b538.svg";
export { ForwardRef as ReactComponent };